<script>
    import {onMount, tick} from "svelte";
    import {getObj, getObjects, saveObj} from '../lib/data.js';
    import {notifier} from '@beyonk/svelte-notifications';
    import Loader from '../Utilities/Loader.svelte';
    import Prompt from '../Navigation/Prompt.svelte';
    import Form from '../Forms/Form.svelte';
    import FindingsSectionEdit from './FindingsSectionEdit.svelte';
    import FindingsSectionView from './FindingSectionView.svelte';
    import SortableList from '../Utilities/SortableList.svelte';
    import SortableTable from '../Utilities/SortableTable.svelte';
    import uuid4 from '../lib/uuid_v4.js';

    import Liquid from 'liquidjs';

    import Editor from '../Forms/Editor.svelte';

    export let params;
    let assessment;

    let prompt;
    let findingsImport = false;

    let findingsSection;
    let dashboardSection;

    let snippetSearch = "";
    let filtered_snippets = [];

    let editors = [];
    let snippets = [];
    let sectionMenu;

    let sectionFields = [
        {
            name: 'name',
            label: 'Section Name',
            placeholder: "Section Name",
            required: true
        },
        {
            name: 'type',
            label: "Section Type",
            type: "select",
            dflt: 'Text',
            choices: {
                static: [
                    {label: 'Text', value: 'Text'},
                    {label: 'Findings', value: 'Findings'},
                    {label: 'Dashboard', value: 'Dashboard'}
                ]
            }
        }
    ]



    $: getAssessment(params.id);

    async function getAssessment(id) {
        assessment = await getObj(params.type, id);
        if (!assessment.data) {
            assessment.data = {
                sections: [{id: uuid4(), name: "Test 1", type: "Text", text: "<h1>Test 1</h1>"}, { id: uuid4(), name: "Test 2", type: "Text", text: "<h1>Test 2</h1>"}]
            }
        }
    }

    async function save() {
        await saveObj(params.type, assessment);

        if (params.type == "assessment") {
            notifier.success("Assessment Saved");
        } else {
            notifier.success("Assessment Template Saved")
        }
    }

    async function addSection() {
        let section_details = await new Promise((resolve) => {
            prompt = {
                title: "Section Name",
                savePrompt: (e) => resolve(e.detail)
            }
        });

        section_details.id = uuid4();

        switch (section_details.type) {
            case "Text":
                section_details.text = `<h1>${section_details.name}</h1>`;
                break;
            case "Findings":
                section_details.findings = [];
                break
            case "Dashboard":
                section_details.items = [];
                section_details.show_header = true;
                break
        }

        console.log(section_details);
        prompt = null;
        assessment.data.sections = [...assessment.data.sections, section_details]
    }

    function deleteSection(section) {
        assessment.data.sections = assessment.data.sections.filter((s) => s != section)
    }

    function sortSections(evt) {
        assessment.data.sections = evt.detail;
    }

    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    function getClosestEditor(el) {
        while (el != document) {
            try {
                if (el.nodeName != "#text" && el.classList.contains("editor")) return el;
            } catch (error) {
                console.log(el)
            }

            el = el.parentNode;
        }

        return
    }

    function dragStart(e) {
        e.dataTransfer.setData('application/json', JSON.stringify({
            'type': e.target.dataset.type,
            'id': e.target.dataset.id
        }));

        e.dataTransfer.setData('text/html', filtered_snippets[e.target.dataset.id].snippet);

        return
        e.dataTransfer.setData('text/html', "<div class=\"image-center\"><figure class=\"image-captioned\" style=\"display:inline-block\"><img alt=\"\" src=\"https://i.imgur.com/FxIun3h.jpeg\" width=\"250\" />\n<figcaption>Caption</figcaption></div>")
    }

    function getDropLocation(e, editor) {
        let relY = (e.clientY - editor.getBoundingClientRect().y);

        if (relY < editor.clientHeight / 2) {
            return "before"
        } else {
            return "after"
        }

    }

    function checkType(e) {
        // check data type
        let json = e.dataTransfer.getData('application/json')

        if (!json) {
            return false;
        }

        let transferType = JSON.parse(json)

        return transferType.type
    }

    function dragover(e) {
        if (checkType(e) == "section") {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let editor = getClosestEditor(e.target);

            // not droppable
            if (!editor) return

            if (getDropLocation(e, editor) == "before") {
                editor.style.borderTopStyle = "dashed";
                editor.style.borderBottomStyle = "";
            } else {
                editor.style.borderTopStyle = "";
                editor.style.borderBottomStyle = "dashed";
            }
        }
    }

    function dragleave(e) {
            if (checkType(e) == "section") {
                let editor = getClosestEditor(e.target);

                // not droppable
                if (!editor) return
                editor.style.borderTopStyle = "";
                editor.style.borderBottomStyle = "";
            }
    }

    function drop(e) {
        if (checkType(e) == "section") {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }
            // remove highlight
            dragleave(e);

            let data = JSON.parse(e.dataTransfer.getData("application/json"));

            let editor = getClosestEditor(e.target);

            // not droppable
            if (!editor) return

            let sections = assessment.data.sections
            if (getDropLocation(e, editor) == "before") {
                sections.splice(editor.dataset.idx, 0, {name: "Test 3", type: "Text", text: "<h1>Test 3</h1><h2>Here We Go!</h2>"})
            } else {
                sections.splice(editor.dataset.idx + 1, 0, {name: "Test 3", type: "Text", text: "<h1>Test 3</h1><h2>Here We Go!</h2>"})
            }

            assessment.data.sections = sections
        }
    }

    function draggable(node) {
        node.addEventListener('dragstart', dragStart, true);
    }

    function droppable(node) {
        node.addEventListener('dragover', dragover, true);
        node.addEventListener('drop', drop, false);
        node.addEventListener('dragleave', dragleave, false);
    }

    function scrollToElement(e) {
        if (e.target != this) return
        document.getElementById(`section_${this.dataset.idx}`).scrollIntoView(true);
    }

    async function loadSnippets() {
        snippets = await getObjects("snippet");
    }

    function showEditFindings() {
        findingsSection = parseInt(this.dataset.idx);
    }

    function updateFindings(evt) {
        console.log(evt.detail);
        assessment.data.sections[findingsSection].table = evt.detail.table;
        assessment.data.sections[findingsSection].findings = evt.detail.findings;
        findingsSection = undefined;
    }

    function addDashboardItem() {
        assessment.data.sections[dashboardSection].items = [...assessment.data.sections[dashboardSection].items, {
            name: "",
            value: "0"
        }]
    }

    function filterSnippets(search, snippets) {
        filtered_snippets = snippets.filter((s) => s.name.toUpperCase().includes(search.toUpperCase()));
    }

    function validateTemplate() {
        const engine = new Liquid.Liquid();
        let errors = [];
        for (let section of assessment.data.sections) {
            if (section.type == "Text") {
                try {
                    let template = engine.parse(section.text);
                } catch (e) {
                    errors.push(`Error in Section ${section.name}: ${e.message}`);
                }
            } else if (section.type == "Dashboard") {
                for (let item of section.items) {
                    console.log(item);
                    try{
                        let template = engine.parse(item.name);
                    } catch (e) {
                        errors.push(`Error in Section ${section.name}: ${e.message}`);
                    }
                }
            }
        }

        if (errors.length) {
            for (let error of errors) {
                notifier.danger(error, 10000);
            }
        } else {
            notifier.success("Template Validated");
        }
    }

    $:filterSnippets(snippetSearch, snippets);
    loadSnippets();

</script>

<style>
    #toolbarTop {
        width: 8.5in;
        margin: auto;
    }

    .sticky {
        position: sticky;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .sticky .buttons {
        padding-top: 1em;
    }

    .menu {
        padding-top: 10px;
    }

    .menu .link {
        min-height: 2rem;
    }

    .draggable {
        cursor: pointer;
    }


    .preview {
        position: relative;
    }

    .preview i {
        margin-top: 17px;
    }

    .preview .dashboard i {
        margin-top: 0;
        line-height: 1.5em;
    }

    .dashboard-edit .field.is-narrow {
        line-height: 2.5em;
    }
</style>

<Loader obj={assessment}>
    {#if !findingsSection}
    <h1 class="title">
        {assessment.company_full_name || assessment.name}
    </h1>
    <div class="columns">
        <div class="column is-narrow">
            <div class="sticky menu">
                <p class="menu-label">Sections</p>
                <ul class="menu-list" bind:this={sectionMenu}>
                    <SortableList list={assessment.data.sections} key="id" let:item={section} let:index={idx} on:sort={sortSections}>
                            <span class="link" on:click={scrollToElement} data-idx={idx}>
                                <span class="icon">
                                    <i class="fas fa-grip-lines"></i>
                                </span>
                                {section.name}
                                <span class="delete is-pulled-right" on:click={() => deleteSection(section)}></span>
                            </span>
                    </SortableList>
                </ul>
                <p class="menu-label">Actions</p>
                <ul class="menu-list">
                    <li><span class="link" on:click={addSection}>Add Section</span></li>
                    <li><a class="link" href="#/assessment/{params.id}/findings/burp" on:click={save}>Manage Burp Findings</a></li>
                    <li><a class="link" href="#/assessment/{params.id}/findings/nessus" on:click={save}>Manage Nessus Findings</a></li>
                </ul>
            </div>
        </div>
        <div class="column" use:droppable>
            <div id="toolbarTop" class="sticky"></div>
            <div class="preview">
                {#each assessment.data.sections as section, idx (section.id)}
                    <div id="section_{idx}">
                        {#if section.type == "Text"}
                            <Editor bind:content={section.text} {idx} />
                        {:else if section.type == "Findings"}
                            <h1>
                                {section.name}
                                <i class="is-pulled-right pointer icon fas fa-edit" data-idx={idx} on:click={showEditFindings}>
                            </h1>

                            <FindingsSectionView {section} />
                        {:else if section.type == "Dashboard"}
                            {#if section.show_header}
                            <h1>
                                {section.name}
                            </h1>
                            {/if}
                            <table class="dashboard">
                                <thead>
                                    <tr>
                                        <td colspan="2">
                                            {section.name}
                                            <i class="is-pulled-right pointer icon fas fa-edit" data-idx={idx} on:click={() => dashboardSection = idx}></i>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <SortableTable list={section.items} key="name" let:item on:sort={(evt) => section.items = evt.detail}>
                                            <td>
                                                {item.name}
                                            </td>
                                            <td class="dashboard-item sev-{item.value}">
                                                ⚫
                                            </td>
                                    </SortableTable>
                                </tbody>
                            </table>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
        <div class="column is-2">
        <div class="sticky">
            <div class="buttons is-right">
                <button class="button" on:click={validateTemplate}>Validate</button>
                <a class="button is-info" href="/api/reports/generate/{assessment.id}" target="_blank" alt="Generate Report" on:click={save}>Generate</a>
                <button class="button is-success" on:click={save}>Save</button>
            </div>
            <div class="snippets panel">
                <p class="panel-heading">Snippets</p>
                <div class="panel-block">
                    <p class="control has-icons-left">
                    <input class="input" type="text" placeholder="Search" bind:value={snippetSearch}>
                    <span class="icon is-left">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </span>
                    </p>
                </div>
                {#each filtered_snippets as snippet, idx}
                    <div class="panel-block draggable" draggable="true" use:draggable data-type="snippet" data-id={idx}>
                        {snippet.name}
                    </div>
                {/each}
            </div>
        </div>
        </div>
    </div>
    {:else}
        <FindingsSectionEdit section={assessment.data.sections[findingsSection]} assessment_id={params.id} on:close={updateFindings} />
    {/if}
</Loader>

{#if prompt}
    <Prompt prompt={prompt.title} on:save={prompt.savePrompt} on:close={() => prompt = undefined}>
        <section class="modal-card-body">
            <Form fields={sectionFields} on:submit={prompt.savePrompt} />
        </section>
    </Prompt>
{/if}

{#if dashboardSection}
    <div class="modal is-active dashboard-edit">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 960px;">
            <header class="modal-card-head">
                <p class="modal-card-title">Dashboard Items</p>
                <button class="delete" aria-label="close" on:click={() => dashboardSection = undefined}></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">Section Name</label>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <input class="input" type="text" placeholder="Name" bind:value={assessment.data.sections[dashboardSection].name}>
                            </p>
                        </div>
                        <div class="field is-narrow">
                            <label class="checkbox">
                                <input type="checkbox" bind:checked={assessment.data.sections[dashboardSection].show_header}>
                                Show Section Header
                            </label>
                        </div>
                    </div>
                </div>
                <button class="button is-pulled-right has-icon" on:click={addDashboardItem}>
                    <span>Add Item</span>
                    <span class="icon">
                        <i class="fas fa-plus"></i>
                    </span>
                </button>

                <table class="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Item Name</th>
                            <th style="width: 170px">Item Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each assessment.data.sections[dashboardSection].items as item}
                            <tr>
                                <td>
                                    <input class="input" bind:value={item.name}>
                                </td>
                                <td>
                                    <div class="select">
                                        <select bind:value={item.value}>
                                            <option value="0">Information</option>
                                            <option value="1">Low</option>
                                            <option value="2">Medium</option>
                                            <option value="3">High</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-info" on:click={() => dashboardSection = undefined}>Done</button>
            </footer>
        </div>
    </div>
{/if}